module.exports = __webpack_public_path__ + "static/media/hoan_tien_2.85a032d6.png";